import React, { useState } from "react";
import { useFetchSubscriptionData } from "../../../apis/settingsApis";
import RoleToggle from "../../Dashboard/_components/RoleToggle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UpdatePaymentModal from "./UpdatePaymentModal";
import { useLanguage } from "../../../context/LanguageContext";

const roles = ["Subscription", "Plans"];
const SubscriptionPlan: React.FC = () => {
  const { data } = useFetchSubscriptionData();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Subscription";
  const { t } = useLanguage();

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Subscription Overview */}
      <div className="bg-white rounded-2xl border border-[#d2d2d2] p-6 2xl:space-y-6 space-y-4 group  transition-all duration-150  ">
        <div className="font-medium text-[#212121] text-lg uppercase">
          {t("Subscription Overview")}
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Subscription Status")}
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {data?.isSubscription?.status ? t("Active") : t("Inactive")}
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Current Plan")}
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {data?.isSubscription?.type ? t(data.isSubscription.type) : ""}
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Next Billing Date")}
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">{t("4 Aug 2024")}</h2>
          </div>

          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Billing Period")}
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {t("Monthly / Yearly")}
            </h2>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Included Shipments")}
            </p>
            <p className="text-[#1E293B] text-lg font-medium">
              {t("30 Free Shipments / Month")}
            </p>
          </div>
          <div className="space-y-1">
            <p className=" text-[#212121]/70 text-sm font-medium">
              {t("Extra Shipment Rate")}
            </p>
            <h2 className="text-[#1E293B] text-lg font-medium">
              {t("0 SAR / Extra Shipment")}
            </h2>
          </div>
        </div>
        <button onClick={()=> navigate('/subscription?tab=Plans')} className="bg-[#FBD037] text-base rounded-full font-medium text-[#000000] border border-[#FBD037]  px-4 py-2 ">
          {t("Change Plan")}
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-[#d2d2d2] p-6 2xl:space-y-6 space-y-4 group cursor-pointer transition-all duration-150 bg-gradient-to-br from-20% from-[#fff] to-[#FBD037]">
        <div className="flex items-center justify-between">
          <div className="font-medium text-[#212121] text-lg">
            {t("Payment Details")}
          </div>
          <div className=" flex items-center gap-2">
            <button
              onClick={() => setOpen(true)}
              className="bg-[#ffffff] text-xs font-medium text-[#000000] border border-[#d2d2d2] px-4 py-2 rounded-full"
            >
              {t("Update")}
            </button>
            <button className="bg-[#ffffff] text-xs font-medium text-[#000000] border border-[#d2d2d2] px-4 py-2 rounded-full">
              {t("Add Payment Method")}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              {t("Payment Method")}
            </h2>
            <p className="text-[#1E293B] text-sm">{t("Card / Online")}</p>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">{t("Card Type")}</h2>
            <div className="flex items-center space-x-1">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                alt="Visa"
                className="h-6 w-10"
              />
              <span>{t("Visa, Mastercard")}</span>
            </div>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              {t("Card Last 4 Digits")}
            </h2>
            <p className="text-[#1E293B] text-sm">**** 1234</p>
          </div>
          <div className="space-y-2">
            <h2 className="font-medium text-[#212121] text-base">
              {t("Billing Name")}
            </h2>
            <p className="text-[#1E293B] text-sm">Muhammad Wasim Akram</p>
          </div>
          <div className="col-span-2">
            <h2 className="font-medium text-[#212121] text-base">
              {t("Billing Address")}
            </h2>
            <p className="text-[#1E293B] text-sm">
              2464 Royal Ln. Mesa, New Jersey 45463
            </p>
          </div>
        </div>
      </div>

      <UpdatePaymentModal onClose={() => setOpen(false)} open={open} />
    </>
  );
};

export default SubscriptionPlan;
